module.exports = __webpack_public_path__ + "static/media/ftp.430fdacf.svg";